import React from "react";
import { Global, css } from "@emotion/react";

const variables = `
  --color-black: #000;
  --color-white: white;
  --color-lightgray: lightgray;
  --color-char: #36313d;
  --color-font: #36313d;
  --color-font-weak: gray;
  --color-article-font: #262930;
  --color-article-heading: #181a1e;
  --color-background: #fefefe;

  --color-primary: #0f0048;
  --color-primary-light: #8f67b8;
  --color-secondary: #ecf0f6;
  --color-secondary-light: #c2f970;
  --color-danger: #dd0426;
  --color-danger-light: #f02d3a;
  --color-success: #18794e;
  --color-success-background: #e8f7ef;
  --color-warning: #a85f00;
  --color-warning-background: #fff4df;

  --color-border: #f0f0f2;
  --color-border-light: #c6c6c6;
  --color-border-light-2: #bbbbbd;

  --color-light-tertiary: #f0cf65;

  --color-google: #db4437;

  --breakpoint-sm: 576px;
  --breakpoint-md: 768px;
  --breakpoint-lg: 992px;
  --breakpoint-xl: 1200px;
  --breakpoint-xxl: 1440px;
`;

export const globalStyles = css`
  :root {
    ${variables}
  }

  body {
    background: unset;
  }

  h1,
  h2,
  h3,
  h4 {
    font-weight: normal;
  }

  h1 {
    font-size: 1.5rem;
    letter-spacing: 0.8px;
  }

  h2 {
    font-size: 1.25rem;
    letter-spacing: 0.6px;
  }

  h3 {
    font-size: 1.1rem;
  }

  h4 {
    font-size: 1rem;
  }

  a {
    text-decoration: none;
  }

  a:hover {
    opacity: 0.6;
  }

  ul {
    list-style-type: none;
  }
`;
const GlobalStyle = () => {
  return <Global styles={globalStyles} />;
};

export default GlobalStyle;
